module.exports = __webpack_public_path__ + "img/13.9d4b09a9.png";